// src/components/Explore/ClubProgramTileList.jsx
// Container for displaying list of Club+Program tiles

import React from 'react';
import ClubProgramTile from './ClubProgramTile';
import styles from './ClubProgramTileList.module.css';

const ClubProgramTileList = ({ 
  clubs, 
  capacityMap = {},
  userClubs = [],
  isLoading = false,
  emptyMessage = "No clubs found matching your criteria"
}) => {
  // Get user membership for each club
  const getUserMembership = (clubId) => {
    return userClubs.find(m => {
      const membershipClubId = m.club?._id || m.club;
      return String(membershipClubId) === String(clubId);
    });
  };

  // Loading state
  if (isLoading) {
    return (
      <div className={styles.loadingState}>
        <div className={styles.spinner}></div>
        <p>Finding clubs and programs...</p>
      </div>
    );
  }

  // Empty state
  if (!clubs || clubs.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>🔍</div>
        <h3>No Results Found</h3>
        <p>{emptyMessage}</p>
        <p className={styles.emptyHint}>
          Try adjusting your filters or increasing the search radius
        </p>
      </div>
    );
  }

  return (
    <div className={styles.tileList}>
      {clubs.map((club) => (
        <ClubProgramTile
          key={club._id}
          club={club}
          capacityMap={capacityMap}
          userMembership={getUserMembership(club._id)}
          defaultExpanded={club.programs?.length <= 3}
        />
      ))}
    </div>
  );
};

export default ClubProgramTileList;










